/*
 *
 * GenericPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 04-Oct-2024
 */

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import { doPopup } from 'Store/actions/popup'
import { getPopupData, getprimaryButtonLoadingPopup } from 'Store/selectors'
import GenericPopUp from './GenericPopUp'

const mapDispatchToProps = (dispatch) => ({
  dispatchAction: (payload) => dispatch(payload),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  data: getPopupData(state),
  primaryButtonLoading: getprimaryButtonLoadingPopup(state)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(GenericPopUp)
